import { Reducer } from 'redux';
import { BookingsSummaryReportState, BookingsSummaryReportStatus } from './BookingsSummaryReportState';
import { BookingsSummaryReport } from 'model/BookingsReport';
import {
    BOOKINGS_SUMMARY_REPORT_GET_START,
    BOOKINGS_SUMMARY_REPORT_GET_SUCCESS,
    BOOKINGS_SUMMARY_REPORT_GET_ERROR,
    BookingsSummaryReportAction
} from 'actions/insights/bookings/bookingsSummary/BookingsSummaryReportActionsTypes';

const emptyBookingSummary: BookingsSummaryReport = {
    totalBookings: 0,
    totalClients: 0,
    totalPets: 0,
    totalServices: 0,
    totalAddons: 0,
    totalProducts: 0,
    totalCustomItems: 0,
    totalValue: 0,
    averageBookingValue: 0
};

const initialState: BookingsSummaryReportState = {
    summary: emptyBookingSummary,
    status: BookingsSummaryReportStatus.Initial,
    loading: false
};

export const BookingsSummaryReportReducer: Reducer<BookingsSummaryReportState, BookingsSummaryReportAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case BOOKINGS_SUMMARY_REPORT_GET_START:
            return {
                ...state,
                status: BookingsSummaryReportStatus.Getting,
                loading: true
            };
        case BOOKINGS_SUMMARY_REPORT_GET_SUCCESS:
            return {
                ...state,
                summary: action.payload.summary,
                status: BookingsSummaryReportStatus.GettingSuccess,
                loading: false
            };
        case BOOKINGS_SUMMARY_REPORT_GET_ERROR:
            return {
                ...state,
                status: BookingsSummaryReportStatus.Error,
                loading: false
            };
        default:
            return state;
    }
};
